export function paramsIsNotNull(actualQuery: any) {
    const filteredQuery = { ...actualQuery };
    for (const key in filteredQuery) {
        if (filteredQuery[key] === null) {
            delete filteredQuery[key];
        }
    }

    return filteredQuery
}